import { createStore } from 'redux-dynamic-modules';
import { getSagaExtension } from 'redux-dynamic-modules-saga';

const getUsersModule = () => {
  return {
    id: 'user',
    reducerMap: {
      user: () => null,
    },
    sagas: [],
  };
};

export const store = createStore(
  {
    initialState: {},
    enhancers: [],
    extensions: [getSagaExtension({})],
  },
  getUsersModule()
);
